<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="market content-wrapper">
      <div class="page-header">{{ $t('editTermsOfPayment') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingTermsOfPaymentList' }">{{ $t('termsOfPayment') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editTermsOfPayment') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 600px">
        <el-form-item :label="$t('name')">
          <el-input v-model="termsOfPayment.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input type="textarea" v-model="termsOfPayment.detail" :rows="5"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="termsOfPayment.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 100%; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onSaveButtonClick">{{ $t('save') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Setting/ManageSetting/TermsOfPayment/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingTermsOfPaymentApi from '@/api/setting/terms-of-payment-api'

export default {
  name: 'SettingTermsOfPaymentEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  props: {
    termsOfPayment: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          detail: '',
          isEnable: STATUS.ENABLE
        }
      }
    }
  },
  data () {
    return {
      isLoading: false,
      STATUS
    }
  },
  created: async function () {
    this.isLoading = true

    if (this.termsOfPayment.id === '' || this.termsOfPayment.id === undefined) {
      this.$router.push({
        name: 'SettingTermsOfPaymentList'
      })
    }

    this.isLoading = false
  },
  methods: {
    onSaveButtonClick: async function () {
      try {
        this.startLoading()
        await SettingTermsOfPaymentApi.update(this.termsOfPayment.id, this.termsOfPayment)

        const title = this.$t('editSuccessTitle')
        const message = this.$t('editSuccessMessage')
        this.showNotificationSuccess(title, message)
        this.$router.push({
          name: 'SettingTermsOfPaymentList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingTermsOfPaymentList'
      })
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
